

$(function () {
    $(".widget-phone-input").each(function (idx, element) {
        var iti = null;
        var $inputTel = $(element).children("input[type=tel]");

        var $inputDialCode = $(element).children("input[type=hidden][data-input=dial_code]");
        var dialCode = $inputDialCode.val();

        var $inputIso2 = $(element).children("input[type=hidden][data-input=iso2]");
        var iso2 = $inputIso2.val();

        var phoneType = $(element).data("phone-type");

        var _processInput = function (input) {
            var value = $(input).val();
            var countryData = null;

            $(element).removeClass("focused");

            if (iti) {
                countryData = iti.getSelectedCountryData();

                if (countryData) {
                    $inputDialCode.val(countryData.dialCode);
                    $inputIso2.val(countryData.iso2);
                }
            }

            if (!value) {
                $(element).removeClass("populated");
            }
            else {
                $(element).addClass("populated");
            }
        };

        $inputTel.focus(function () {
            var isreadonly = $(this).prop("readonly");

            if (!isreadonly) {
                $(element).addClass("populated")
                    .addClass("focused");
            }
        });

        $inputTel.change(function () {
            _processInput(this);
        })

        $inputTel.blur(function () {
            _processInput(this);
        });

        if (window.intlTelInput && $inputTel.length > 0) {
            iti = window.intlTelInput($inputTel[0], {
                utilsScript: "/content/libs/intl-tel-input-utils.js",
                initialCountry: iso2 || "au",
                separateDialCode: true,
                nationalMode: false,
                autoPlaceholder: "polite",
                preferredCountries: ["au", "nz"],
                placeholderNumberType: phoneType,
                customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                    return "e.g. " + selectedCountryPlaceholder;
                }
            });

            if (iti && iti.promise) {
                iti.promise.then(function () {
                    if ($inputTel.length > 0)
                        _processInput($inputTel.get(0));
                });
            }
            else {
                setTimeout(function () {
                    if ($inputTel.length > 0)
                        _processInput($inputTel.get(0));
                }, 1000);
            }
        }
    })
})